import { memo } from 'react'
import { Rect, Svg } from 'react-native-svg'

interface SvgIconProps {
  color?: string
  size?: number
}

export const SvgRect = memo(({ color = '#F7F6ED', size = 24 }: SvgIconProps) => (
  <Svg width={size} height={size} viewBox="0 0 13 14" fill="none">
    <Rect width="14.0056" height="9.17609" rx="4.32494" fill={color} />
  </Svg>
))

SvgRect.displayName = 'SvgRect'
